import { FormStep } from '@r-and-a-shared-ui/common-forms-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { MEMBERSHIP_MODELS, PLAYER_PORTALS_MODELS, SSO_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: ()=>FormStep,
  mapEntryToProps: (entry: SSO_MODELS.FormStep & MEMBERSHIP_MODELS.FormStep & PLAYER_PORTALS_MODELS.FormStep) =>
    kontentAiDataMapping.form_step(entry),
};
